import { useEffect, useState } from 'react';

import { useQuery } from 'apps/promo/hooks/useQuery';

export const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value]);

    return debouncedValue;
};

export const getZendeskLocale = (lang, country) => {
    switch (lang) {
        case 'ru':
        case 'uk':
        case 'uz':
        case 'fr':
        case 'de':
            return lang;
        case 'zh':
            return 'zh-cn';
        case 'en':
            return country === 'us' ? 'en-us' : 'en-gb';
        case 'es':
            return 'es-419';
        case 'fil':
            return 'fil';
        default:
            return 'en-gb';
    }
};

export const useGetQueryParams = () => {
    const query = useQuery();
    return Object.fromEntries(query.entries());
};

export const getHelpCenterUrl = (href, params) => {
    if (!params || Object.keys(params).length === 0) {
        return href;
    }
    const queryParams = Object.entries(params).map(([key, value]) => {
        return `${key}=${value}`;
    });
    const queryParamsString = queryParams.join('&');
    return `${href}?${queryParamsString}`;
};

export const getBgClassName = (bgColor) => {
    if (!bgColor) return '';

    return `bg${bgColor.charAt(0).toUpperCase()}${bgColor.slice(1)}`;
};
